import { urlFor } from "@/sanity/lib/image";
import { sanityClient } from "@/sanity/lib/client";
import BlogCard from "@/components/blog/BlogCard.js"
import styles from './blog.module.scss'
import Header from '@/components/header'
import Head from 'next/head'
import { useState } from 'react'
import { getSiteSettings } from '@/lib/getSiteSettings';
import { BLOG_POSTS_QUERY } from '../../sanity/lib/queries'


export async function getServerSideProps() {
  const siteSettings = await getSiteSettings();
  const initialPosts = await sanityClient.fetch(BLOG_POSTS_QUERY(0, 9));
  return {
    props: {
      siteSettings,
      initialPosts
    }
  };
}

export default function Blog({ initialPosts }) {
  const [posts, setPosts] = useState(initialPosts);
  const [offset, setOffset] = useState(initialPosts.length); // Start from how many we initially fetched
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(initialPosts.length === 9); // If initial batch is full, assume more exist

  const loadMorePosts = async () => {
    setLoading(true);
    const newPosts = await sanityClient.fetch(BLOG_POSTS_QUERY(offset, offset + 9));

    setPosts(prev => [...prev, ...newPosts]);
    setOffset(prev => prev + newPosts.length);

    if (newPosts.length < 9) {
      setHasMore(false); // No more posts left
    }

    setLoading(false);
  };

  return (
    <>
      <Head>
        <title>Blog | Purple Lotus</title>
        <meta property="og:title" content="Cannabis Articles & Latest Weed News in San Jose | Purple Lotus" key="title" />
        <meta name="description" content="Browse and read the best articles about marijuana, cannabis, and alternative health. Read our how-to guides, FAQ and other information on cannabis." />
      </Head>

      <main className="bg-neutral-200">
        <Header
          title="Lotus Blog"
          src="/images/purple-lotus-blog.jpg"
          position="50% 30%"
        />

        <section className="container row-slim">
          <div className={styles.posts}>
            {loading && posts.length === 0 ? (
              <p>Loading...</p>
            ) : posts.length === 0 ? (
              <p style={{
                textAlign: 'center',
                fontSize: '1.2rem',
                color: '#777',
                marginTop: '2rem'
              }}>
                No posts available</p>
            ) : (
              posts.map(post => (
                <BlogCard
                  key={post._id}
                  image={urlFor(post.mainImage).width(454).height(227).url()}
                  title={post.title}
                  category={post.categories[0]?.title}
                  url={post?.slug.current}
                />
              ))
            )}
          </div>

          <div style={{ display: 'flex', justifyContent: "center", margin: "2rem 0rem" }}>
            {loading ? (
              <p>Loading...</p>
            ) : hasMore ? (
              <button className="button" data-type="primary" onClick={loadMorePosts}>
                Load more posts
              </button>
            ) : posts.length > 0 ? (
              <p style={{ textAlign: "center", marginTop: "1rem" }}>You’ve reached the end.</p>
            ) : null}
          </div>
        </section>
      </main>
    </>
  );
}
